import * as request from "request-promise-native";

export async function getAMFDeclarations(instrument, start, rows) {
    const params = {
        dataset: "flux-amf-new-prod@dilaamf",
        q: `code_isin_nom_sc:${instrument.na}`,
        rows: rows,
        start: start,
        sort: 'uin_dat_amf'
    }
    const options = {
        method: 'GET',
        url: `https://data.opendatasoft.com/api/records/1.0/search/`,
        qs: params,
        headers: {
        }
    };
    const result = await request.get(options);
    return JSON.parse(result);
}